import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaAward } from "react-icons/fa6";
import HyvidRewards from "./index";
import { MODULE_MY_POINTS } from "variables/constants";

const hyvidPointRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Hyvid Points",
        basePath: "hyvid-points",
        mainComponent: <HyvidRewards />,
        layout: "/console",	   
        icon: <FaAward className="icon-item" />,
        subTitle:"Hyvid Point",
        level:5,
        moduleId: MODULE_MY_POINTS,
    })
]

export default hyvidPointRoutes;